"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartColorSelector = void 0;
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var chartColorSelector = function (props, color, index) {
    return escapeCss_1.default(props.theme.chartColors[color][index]);
};
exports.chartColorSelector = chartColorSelector;
var getChartColor = function (color, index) {
    return function (props) { return exports.chartColorSelector(props, color, index); };
};
exports.default = getChartColor;
//# sourceMappingURL=index.js.map